import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcCategoryFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.36 18.782a1.25 1.25 0 0 1 0 2.486l-.128.007H2.25a1.25 1.25 0 0 1 0-2.5h11.982zm.553-15.542a6.98 6.98 0 0 1 5.714 10.984l2.616 2.617.086.094a1.25 1.25 0 0 1-1.759 1.76l-.094-.087-2.626-2.626A6.98 6.98 0 1 1 14.914 3.24m-9.219 9.042a1.25 1.25 0 0 1 0 2.486l-.128.007H2.25a1.25 1.25 0 0 1 0-2.5h3.316zm9.22-6.542a4.48 4.48 0 1 0 0 8.96 4.48 4.48 0 0 0 0-8.96m-9.204.042a1.25 1.25 0 0 1 0 2.486l-.128.007H2.266a1.25 1.25 0 0 1 0-2.5h3.316z"
  }));
}
var IcCategoryFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcCategoryFill));

export { IcCategoryFill as I };
